// extracted by mini-css-extract-plugin
module.exports = {"serviceTitle":"ServiceTwo_serviceTitle__1nxV0","bestService":"ServiceTwo_bestService__1E9IU","icon":"ServiceTwo_icon__3pxzf","content":"ServiceTwo_content__2sdF1"};